/**
 * RightFront - the right column's panels and the switch between them.
 *
 * Story, Stealth and Target, as tabs. STEALTH'S IS OFFERED ONLY WHILE THE
 * TABLE IS IN STEALTH (the caller passes it only then): outside it there
 * is no ladder running, and a pane reading "Unaware - nobody is looking
 * your way" over a fight was simply wrong (user, 2026-10-05). The GM can
 * still look by peeking at the mode. THE TARGET PANEL STAYS MOUNTED
 * whatever is in front (it attaches refs and observers at mount) and is
 * `hidden` when it is not. Every other pane is rendered only while it is
 * in front: its state lives in hooks, and a hidden copy of the cast put a
 * second button with each character's name in the page - which is what a
 * locator by text, or a screen reader's find, then met twice.
 *
 * @param {object} props
 * @param {{ front: 'story' | 'stealth' | 'target', show: Function }} props.rightFront
 * @param {React.ReactNode} props.story
 * @param {React.ReactNode} [props.stealth] - absent outside Stealth
 * @param {React.ReactNode} props.target
 */
import styles from '../../styles/Story.module.css';

const TABS = [
  { id: 'story', label: 'Story' },
  { id: 'stealth', label: 'Stealth' },
  { id: 'target', label: 'Target', staysMounted: true },
];

export default function RightFront({ rightFront, story, stealth, target }) {
  const panes = { story, stealth, target };
  // A pane the caller did not hand over is not offered: Stealth's, outside Stealth.
  const tabs = TABS.filter((tab) => panes[tab.id]);
  return (
    <>
      <div className={styles.switcher} role="tablist" aria-label="Right column">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            id={`right-tab-${tab.id}`}
            aria-selected={rightFront.front === tab.id}
            aria-controls={`right-pane-${tab.id}`}
            className={styles.tab}
            data-testid={`right-front-${tab.id}`}
            onClick={() => rightFront.show(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {tabs.map((tab) => (
        <div
          key={tab.id}
          role="tabpanel"
          id={`right-pane-${tab.id}`}
          aria-labelledby={`right-tab-${tab.id}`}
          className={styles.pane}
          hidden={rightFront.front !== tab.id}
        >
          {(tab.staysMounted || rightFront.front === tab.id) && panes[tab.id]}
        </div>
      ))}
    </>
  );
}
